import { render, staticRenderFns } from "./infoMessage.vue?vue&type=template&id=4ee3d20c&scoped=true&"
import script from "./infoMessage.vue?vue&type=script&lang=js&"
export * from "./infoMessage.vue?vue&type=script&lang=js&"
import style0 from "./infoMessage.vue?vue&type=style&index=0&id=4ee3d20c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee3d20c",
  null
  
)

export default component.exports